import styled from 'styled-components';
import WithDirection from '../../config/withDirection';

const CampaignListWrapper = styled.div`
    .header-row {
        h1 {
            margin: 0;
            line-height: 36px;
            font-family: 'Montserrat';
            font-size: 18px;
            font-weight: 300;
            color: rgba(255, 255, 255, 1);
            letter-spacing: 0.06em;
        }

        &:first-child { margin-bottom: 14px; }
    }

    @media screen and (max-width: 767px) {
        header-row:first-child { margin-bottom: 0; }
        .campaign-list { padding: 26px 16px 104px 16px; }
    }
`;
export default WithDirection(CampaignListWrapper);



// WEBPACK FOOTER //
// ./src/containers/CampaignList/style.js